import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine
} from 'recharts';
import './Charts.css';
import { formatIndianCurrency, formatChartAxis } from '../../../utils/currencyFormatter';

const RevenueChart = ({ data, showTarget = true }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="tooltip-label">{payload[0].payload.dayName}</p>
          <p className="tooltip-value">
            Revenue: <strong>{formatIndianCurrency(payload[0].value, true, 2)}</strong>
          </p>
          {payload[0].payload.orders && (
            <p className="tooltip-sub">Orders: {payload[0].payload.orders}</p>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-container">
      <h3 className="chart-title">Daily Revenue Trend</h3>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#3b82f6" stopOpacity={0.1} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis 
            dataKey="dayName" 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <YAxis 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
            tickFormatter={(value) => formatChartAxis(value)}
          />
          <Tooltip content={<CustomTooltip />} />
          {showTarget && data[0]?.target && (
            <ReferenceLine 
              y={data[0].target} 
              stroke="#10b981" 
              strokeDasharray="5 5" 
              label={{ value: 'Target', fill: '#10b981', fontSize: 12 }}
            />
          )}
          <Area
            type="monotone"
            dataKey="revenue"
            stroke="#3b82f6"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorRevenue)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RevenueChart;

